<div *ngIf="app.moduleType?.id == 17" class="bg-blue-100 border-blue-500 zayav border-2 rounded mb-4 p-3">
  <div class="flex w-full justify-between test-type-name">
    <div class="text-lg w-full text-blue-500 font-bold uppercase">
      <span *ngIf="translate.currentLang == 'kz'">{{ app.appType.name.kk }}</span>
      <span *ngIf="translate.currentLang == 'ru'">{{ app.appType.name.ru }}</span>
    </div>
    <div class="text-lg w-full text-green-400 font-bold uppercase">
      <span *ngIf="translate.currentLang == 'kz'">{{ app.testStatus.name.kk }}</span>
      <span *ngIf="translate.currentLang == 'ru'">{{ app.testStatus.name.ru }}</span>
      <small *ngIf="app.testStatus.id == 23" style="font-size: x-small"
             class="flex justify-between text-black font-bold">
        <span *ngIf="translate.currentLang == 'kz'">
          {{ app.testStatus.description.kk }}
        </span>
        <span *ngIf="translate.currentLang == 'ru'">
          {{ app.testStatus.description.ru }}
        </span>
      </small>
    </div>
  </div>
  <div class="flex w-full justify-between test-type-name">
    <div class="py-2 font-bold">
      <span *ngIf="translate.currentLang == 'kz'">{{ app.appType.name.kk }}</span>
      <span *ngIf="translate.currentLang == 'ru'">{{ app.appType.name.ru }}</span>
    </div>
    <div class="py-2 content-end font-bold">
      {{ 'AppDate' | translate }}: {{ app.createdAt * 1000 | date: 'dd.MM.yyy H:mm' }}
    </div>
  </div>
  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div class="card">
      <div class="card-body">
        <div class="px-3 text-gray-600">
          <div *ngIf="app.moduleType.id == 2" class="pb-2 font-bold">
            <span *ngIf="translate.currentLang == 'kz'">{{ app.season.name.kk }}</span>
            <span *ngIf="translate.currentLang == 'ru'">{{ app.season.name.ru }}</span>
          </div>
          <div class="mb-2">
            {{ 'IKT' | translate }} : {{ app.formattedId }}
          </div>
          <div class="mb-2">
            {{ 'IIN' | translate }} : {{ app.iin }}
          </div>
          <div class="mb-2">
            {{ 'fio' | translate }} : {{ app.lastname }} {{ app.firstname }} {{ app.patronymic }}
          </div>
          <div class="mb-2">
            {{ 'numCert' | translate }} {{ app.certificateId }}
          </div>
          <div class="mb-2 font-bold">
            {{ 'dataCert' | translate }}
          </div>
          <div class="mb-2">
            {{ 'numEnt' | translate }} {{ app.entCertificateId }}
          </div>
          <div class="mb-2">
            {{ 'dateEnt' | translate }} {{ app.entTestDate }}
          </div>
          <div class="mb-2">
            {{ 'numKaztest' | translate }} {{ app.kazTestCertificateId }}
          </div>
          <div class="mb-2">
            {{ 'dateKaztest' | translate }} {{ app.kazTestTestDate }}
          </div>
          <table
            *ngIf="app.testStatus.id === 7 || app.testStatus.id === 6 || app.testStatus.id === 20 || app.testStatus.id === 22"
            class="table table-bordered pc-version">
            <thead>
            <tr class="text-center">
              <th class="w-6/12">{{ 'Subject' | translate }}</th>
              <th class="w-2/12">{{ 'subjectBall' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let subject of app.subjects">
              <td>
                {{ subject.subject.name[translate.currentLang === 'ru' ? 'ru' : 'kk'] }}
              </td>
              <td class="text-center">
                {{ subject.score }}
              </td>
            </tr>
            <tr>
              <td colspan="1" class="w-3/4 text-right">{{ 'totalScore' | translate }}</td>
              <td class="text-center">{{ app.totalScore }}</td>
            </tr>
            </tbody>
          </table>

          <table
            *ngIf="app.testStatus.id === 7 || app.testStatus.id === 6 || app.testStatus.id === 20 || app.testStatus.id === 22"
            class="table table-bordered mobile-version">
            <thead>
            <tr class="text-center">
              <th class="w-6/12">{{ 'Subject' | translate }}</th>
              <th class="w-2/12">{{ 'subjectBall' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let subject of app.subjects">
              <td>
                {{ subject.subject.name[translate.currentLang === 'ru' ? 'ru' : 'kk'] }}
              </td>
              <td class="text-center">
                {{ subject.score }}
              </td>
            </tr>
            <tr>
              <td colspan="1" class="w-3/4 text-right">{{ 'totalScore' | translate }}</td>
              <td class="text-center">{{ app.totalScore }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="flex w-full justify-end mt-2 zayav-buttons px-3">
          <button (click)="checkCertificate(app.id, app.iin, app.testPeriodYear, 1)" *ngIf="app.testStatus.id == 7"
                  class="w-1/2 bg-green-400 zayav-button tracking-wide w-64 hover:bg-green-700 text-white font-hairline py-1 px-3 rounded">
            {{ 'CheckCertificate' | translate }}
          </button>
        </div>
        <button printSectionId="themes" [useExistingCss]="true" printTitle="ҰТО/НЦТ" ngxPrint
                *ngIf="app.testStatus.id == 7 && themeSubjects.length > 0"
                class="w-1/2 bg-green-400 mr-3 zayav-button tracking-wide w-64 hover:bg-green-700 text-white font-hairline py-1 px-3 rounded">
          Печать
        </button>
      </div>
    </div>
  </div>
  <div (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"
       class="text-center arr-btn cursor-pointer">
    <svg *ngIf="isCollapsed" class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
      <path
        d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM382.6 302.6l-103.1 103.1C270.7 414.6 260.9 416 256 416c-4.881 0-14.65-1.391-22.65-9.398L129.4 302.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 306.8V128c0-17.69 14.33-32 32-32s32 14.31 32 32v178.8l49.38-49.38c12.5-12.5 32.75-12.5 45.25 0S395.1 290.1 382.6 302.6z"/>
    </svg>
    <svg *ngIf="!isCollapsed" class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
      <path
        d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM382.6 254.6c-12.5 12.5-32.75 12.5-45.25 0L288 205.3V384c0 17.69-14.33 32-32 32s-32-14.31-32-32V205.3L174.6 254.6c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l103.1-103.1C241.3 97.4 251.1 96 256 96c4.881 0 14.65 1.391 22.65 9.398l103.1 103.1C395.1 221.9 395.1 242.1 382.6 254.6z"/>
    </svg>
  </div>
</div>
